// import React, { useState, useEffect, useRef } from "react";
// import "../styles/user_management_styles.css";
// import Navbar from "./Navbar.js";
// import "bootstrap/dist/css/bootstrap.min.css";
// import Table from "./Table.js";
// import useFetch from "./useFetch.js";
// import swal from "sweetalert";
// import axios from "axios";
// import $ from "jquery";
// import config from "../config.js";
// import Cookie from "universal-cookie";
// import mixpanel from "mixpanel-browser";
// import { decrypt } from "./useCryptoJS";
// import * as XLSX from "xlsx";
// import {
//   Table as MuiTable,
//   TableHead,
//   TableBody,
//   TableRow,
//   TableCell,
//   Checkbox,
//   IconButton,
//   Chip,
// } from "@mui/material";
// import { Edit2, Trash2 } from "lucide-react";

// // MUI imports
// import {
//   Box,
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Divider,
//   Button,
//   TextField,
//   FormControlLabel,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
// } from "@mui/material";
// import useMediaQuery from "@mui/material/useMediaQuery";

// import {
//   Download,
//   Upload,
//   Plus,
//   LayoutDashboard,
//   Database,
//   ChevronDown,
// } from "lucide-react";

// const HTTPSources = (props) => {
//   // const cookies = new Cookie();
//   // const [ursource, setUrsource] = useState("0000");
//   // const isMobile = useMediaQuery("(max-width:900px)");

//   // const [selectedRows, setSelectedRows] = useState([]);

//   // let isInEditableMode = false;
//   // let editableData = {};

//   // let actionInitiatingUser = -1;
//   // let userToken = "";
//   // try {
//   //   userToken = cookies.get("userToken");
//   //   actionInitiatingUser = parseInt(cookies.get("userID"));
//   // } catch (error) {}

//   // const {
//   //   isPending,
//   //   data: sources,
//   //   error,
//   // } = useFetch({
//   //   actionInitiatingUser: { userID: actionInitiatingUser },
//   //   URL: config.BACKEND_URL + "/logger_sources/sources/http",
//   // });

//   // useEffect(() => {
//   //   setUrsource(decrypt(cookies.get("ursource")));
//   // }, []);

//   // const headers = {
//   //   Authorization: `Bearer ${userToken}`,
//   //   "Content-Type": "application/json",
//   // };

//   // const setEditableData = function (value) {
//   //   editableData = value;

//   //   $("#httpName")[0].value = value.name || "";
//   //   $("#httpURL")[0].value = value.URL || "";
//   //   $("#httpKey")[0].value = value.key || "";
//   //   $("#httpMethod")[0].value = (value.method || "GET")
//   //     .toString()
//   //     .toUpperCase();

//   //   // Updated to set the value of the new dropdown select
//   //   const isEnabled =
//   //     value.enable === true ||
//   //     value.enable === 1 ||
//   //     value.enable === "1" ||
//   //     value.enable === "true";

//   //   $("#httpEnable").val(isEnabled ? "true" : "false");

//   //   document.querySelector("#httpFormSubmit").innerText = "Update";
//   //   isInEditableMode = true;

//   //   const formEl = document.getElementById("http-form-section");
//   //   if (formEl) {
//   //     formEl.scrollIntoView({
//   //       behavior: "smooth",
//   //       block: "start",
//   //     });
//   //   }
//   // };

//   // const handleDeleteButton = (e) => {
//   //   e.preventDefault();
//   //   mixpanel.track("HTTP Delete Button Clicked", {
//   //     userID: cookies.get("userID"),
//   //   });
//   //   if (ursource.charAt(3) != "1") {
//   //     swal("No Permission", "You cannot perform delete operation", "error");
//   //     return;
//   //   }
//   //   if (selectedRows.length === 0) {
//   //     swal(
//   //       "Invalid selection!",
//   //       "You have no selected any rows for deleting!",
//   //       "error"
//   //     );
//   //   } else {
//   //     swal({
//   //       title: "Are you sure?",
//   //       text: "Do you want to delete the selected data sources?",
//   //       icon: "warning",
//   //       buttons: true,
//   //       dangerMode: true,
//   //     }).then(async (willDelete) => {
//   //       if (willDelete) {
//   //         await axios
//   //           .post(
//   //             config.BACKEND_URL + "/logger_sources/sources/delete-by-ids",
//   //             {
//   //               sourceIDs: selectedRows.map((row) => row.id),
//   //               actionInitiatingUser,
//   //             },
//   //             { headers }
//   //           )
//   //           .then((res) => {
//   //             swal(
//   //               "Sources deleted successfully!",
//   //               "Click on OK to continue...",
//   //               "success"
//   //             ).then(() => {
//   //               window.location.reload();
//   //             });
//   //           })
//   //           .catch((err) => {
//   //             swal(
//   //               "Error!",
//   //               "Your selected sources have not been deleted because of a server error!",
//   //               "error"
//   //             );
//   //           });
//   //       } else {
//   //         swal(
//   //           "Cancelled!",
//   //           "Your selected sources have not been deleted!",
//   //           "error"
//   //         );
//   //       }
//   //     });
//   //   }
//   // };

//   // const handleEditButton = (e) => {
//   //   e.preventDefault();
//   //   mixpanel.track("HTTP Edit Button Clicked", {
//   //     userID: cookies.get("userID"),
//   //   });
//   //   if (ursource.charAt(2) != "1") {
//   //     swal("No Permission", "You cannot perform edit operation", "error");
//   //     return;
//   //   }
//   //   if (selectedRows.length === 0) {
//   //     swal("Please select a row to edit!", "", "error");
//   //   } else if (selectedRows.length > 1) {
//   //     swal("Please select only one row to edit!", "", "error");
//   //   } else {
//   //     setEditableData(selectedRows[0]);
//   //   }
//   // };
//   // // Complete handleHTTPForm method - replace the entire function

//   // const handleHTTPForm = async (e) => {
//   //   e.preventDefault();
//   //   mixpanel.track("HTTP Submit Button Clicked", {
//   //     userID: cookies.get("userID"),
//   //   });
//   //   if (ursource.charAt(2) == "0" && ursource.charAt(1) == "0") {
//   //     swal(
//   //       "No Permission",
//   //       "You cannot perform create/edit operation",
//   //       "error"
//   //     );
//   //     return;
//   //   }

//   //   const name = $("#httpName")[0].value;
//   //   const URL = $("#httpURL")[0].value;
//   //   const key = $("#httpKey")[0].value;
//   //   const method = $("#httpMethod")[0].value.toString().toUpperCase();

//   //   // Updated to get value from dropdown select
//   //   const enable = $("#httpEnable").val() === "true";

//   //   const URLValidator = true;

//   //   if (!isInEditableMode) {
//   //     // CREATE MODE
//   //     if (URLValidator) {
//   //       swal({
//   //         title: "Are you sure?",
//   //         text: "Do you want to add the data source?",
//   //         icon: "warning",
//   //         buttons: true,
//   //         dangerMode: true,
//   //       }).then(async (willDelete) => {
//   //         if (willDelete) {
//   //           try {
//   //             const createBody = {
//   //               name,
//   //               type: "HTTP",
//   //               data: { URL, method, key },
//   //               enable,
//   //               actionInitiatingUser,
//   //             };
//   //             await axios
//   //               .post(
//   //                 config.BACKEND_URL + "/logger_sources/sources/http",
//   //                 createBody,
//   //                 { headers }
//   //               )
//   //               .then((res) => {
//   //                 swal(
//   //                   "Source added successfully!",
//   //                   "Click on OK to continue...",
//   //                   "success"
//   //                 ).then(() => {
//   //                   window.location.reload();
//   //                 });
//   //               })
//   //               .catch((err) => {
//   //                 console.log(err);
//   //               });
//   //           } catch (err) {
//   //             console.log("Error: ", err);
//   //             swal(
//   //               "Error!",
//   //               "Your data source has not been added because of an error!",
//   //               "error"
//   //             );
//   //           }
//   //         } else {
//   //           swal("Data source not added!", "", "info");
//   //         }
//   //       });
//   //     } else {
//   //       swal("Invalid URL!", "Data source could not be added!", "error");
//   //     }
//   //   } else {
//   //     // EDIT MODE - Fixed data structure
//   //     const data = {
//   //       name,
//   //       type: "HTTP",
//   //       URL,
//   //       key,
//   //       method,
//   //       enable,
//   //       actionInitiatingUser,
//   //       data: { URL, method, key },
//   //     };

//   //     if (URLValidator) {
//   //       swal({
//   //         title: "Are you sure?",
//   //         text: "Do you want to edit the selected data source?",
//   //         icon: "warning",
//   //         buttons: true,
//   //         dangerMode: true,
//   //       }).then(async (willEdit) => {
//   //         if (willEdit) {
//   //           try {
//   //             await axios.patch(
//   //               config.BACKEND_URL +
//   //                 `/logger_sources/sources/http/${editableData.id}`,
//   //               data,
//   //               { headers }
//   //             );
//   //             swal(
//   //               "Source updated successfully!",
//   //               "Click on OK to refresh the page...",
//   //               "success"
//   //             ).then(() => {
//   //               window.location.reload();
//   //             });
//   //           } catch (err) {
//   //             console.log(err);
//   //             swal(
//   //               "Could not update source!",
//   //               err.response?.data?.message || "Unknown error",
//   //               "error"
//   //             );
//   //           }
//   //         } else {
//   //           swal("The selected source has not been edited!", "", "info");
//   //         }
//   //       });
//   //     } else {
//   //       swal("Invalid URL!", "Data source could not be updated!", "error");
//   //     }
//   //   }
//   // };

//   // const handleFileUpload = (event) => {
//   //   if (ursource.charAt(1) !== "1") {
//   //     swal("No Permission", "You cannot perform create operation", "error");
//   //     return;
//   //   }
//   //   const file = event.target.files[0];
//   //   if (!file) return;

//   //   const reader = new FileReader();
//   //   reader.onload = (e) => {
//   //     const data = e.target.result;
//   //     const workbook = XLSX.read(data, { type: "binary" });
//   //     const sheetName = workbook.SheetNames[0];
//   //     const worksheet = workbook.Sheets[sheetName];
//   //     const jsonData = XLSX.utils.sheet_to_json(worksheet);
//   //     processExcelData(jsonData);
//   //   };
//   //   reader.readAsBinaryString(file);
//   // };

//   // const rowKey = (row) =>
//   //   `${String(row.name).trim().toLowerCase()}|${String(row.URL)
//   //     .trim()
//   //     .toString()}|${String(row.method).trim().toUpperCase()}`;

//   // const validateRow = (row) => {
//   //   const requiredColumns = ["name", "URL", "key", "method", "enable"];
//   //   for (const col of requiredColumns) {
//   //     if (!row[col] || row[col].toString().trim() === "") {
//   //       return {
//   //         valid: false,
//   //         message: `Missing or empty required field: ${col}`,
//   //       };
//   //     }
//   //   }
//   //   const method = String(row.method).toUpperCase().trim();
//   //   if (!["GET", "POST"].includes(method)) {
//   //     return { valid: false, message: "Method must be GET or POST" };
//   //   }
//   //   const enableVal = String(row.enable).toLowerCase().trim();
//   //   if (!["true", "false", "1", "0"].includes(enableVal)) {
//   //     return {
//   //       valid: false,
//   //       message: "Enable must be true, false, 1, or 0",
//   //     };
//   //   }
//   //   return { valid: true };
//   // };

//   // const processExcelData = async (jsonData) => {
//   //   const invalidRows = [];
//   //   const validRows = [];

//   //   jsonData.forEach((row, index) => {
//   //     const validation = validateRow(row);
//   //     if (validation.valid) {
//   //       validRows.push({ row, rowIndex: index + 2 });
//   //     } else {
//   //       invalidRows.push({ rowIndex: index + 2, message: validation.message });
//   //     }
//   //   });

//   //   if (validRows.length === 0) {
//   //     swal(
//   //       "No Valid Rows",
//   //       "The uploaded file contains no valid rows to add.",
//   //       "error"
//   //     );
//   //     return;
//   //   }

//   //   const seen = new Map();
//   //   const dedupedRows = [];
//   //   const skippedFileDupes = [];

//   //   for (const { row, rowIndex } of validRows) {
//   //     const key = rowKey(row);
//   //     if (seen.has(key)) {
//   //       skippedFileDupes.push({
//   //         rowIndex,
//   //         message: `Duplicate in file (same as row ${seen.get(key)})`,
//   //       });
//   //       continue;
//   //     }
//   //     seen.set(key, rowIndex);
//   //     dedupedRows.push({ row, rowIndex });
//   //   }

//   //   const existingKeys = new Set(
//   //     (sources?.data || [])
//   //       .map((s) => ({
//   //         name: String(s.name || "")
//   //           .trim()
//   //           .toLowerCase(),
//   //         URL: String(s.URL || "").trim(),
//   //         method: String(s.method || "")
//   //           .trim()
//   //           .toUpperCase(),
//   //       }))
//   //       .map((s) => `${s.name}|${s.URL}|${s.method}`)
//   //   );

//   //   const toCreate = [];
//   //   const skippedExistingDupes = [];
//   //   for (const { row, rowIndex } of dedupedRows) {
//   //     const key = rowKey(row);
//   //     if (existingKeys.has(key)) {
//   //       skippedExistingDupes.push({
//   //         rowIndex,
//   //         message: "Duplicate of an existing HTTP source",
//   //       });
//   //       continue;
//   //     }
//   //     toCreate.push({ row, rowIndex });
//   //   }

//   //   if (toCreate.length === 0) {
//   //     const msg = [
//   //       "No rows to upload.",
//   //       skippedFileDupes.length
//   //         ? `Skipped ${skippedFileDupes.length} duplicate row(s) within file.`
//   //         : "",
//   //       skippedExistingDupes.length
//   //         ? `Skipped ${skippedExistingDupes.length} duplicate row(s) that already exist.`
//   //         : "",
//   //       invalidRows.length
//   //         ? `Skipped ${invalidRows.length} invalid row(s).`
//   //         : "",
//   //     ]
//   //       .filter(Boolean)
//   //       .join(" ");
//   //     swal("Nothing Uploaded", msg, "info");
//   //     return;
//   //   }

//   //   const requests = toCreate.map(({ row }) => {
//   //     const method = String(row.method).toUpperCase().trim();
//   //     const enableBool = ["true", "1", 1, true].includes(
//   //       typeof row.enable === "string"
//   //         ? row.enable.toLowerCase().trim()
//   //         : row.enable
//   //     );

//   //     const source = {
//   //       name: row.name,
//   //       type: "HTTP",
//   //       data: { URL: row.URL, method, key: row.key },
//   //       enable: enableBool,
//   //       actionInitiatingUser,
//   //     };

//   //     return axios.post(
//   //       `${config.BACKEND_URL}/logger_sources/sources/http`,
//   //       source,
//   //       { headers }
//   //     );
//   //   });

//   //   try {
//   //     const settled = await Promise.allSettled(requests);
//   //     const successes = settled.filter((r) => r.status === "fulfilled").length;
//   //     const failures = settled.filter((r) => r.status === "rejected").length;

//   //     let message = `Uploaded ${successes} source(s).`;
//   //     if (failures > 0) message += ` Failed ${failures} source(s).`;
//   //     if (skippedFileDupes.length > 0)
//   //       message += ` Skipped ${skippedFileDupes.length} duplicate row(s) within file.`;
//   //     if (skippedExistingDupes.length > 0)
//   //       message += ` Skipped ${skippedExistingDupes.length} duplicate row(s) already present.`;
//   //     if (invalidRows.length > 0)
//   //       message += ` Skipped ${invalidRows.length} invalid row(s).`;

//   //     swal("Upload Complete", message, "info").then(() =>
//   //       window.location.reload()
//   //     );
//   //   } catch (err) {
//   //     console.error("Unexpected error during upload:", err);
//   //     swal(
//   //       "Error",
//   //       "An unexpected error occurred while uploading sources.",
//   //       "error"
//   //     );
//   //   }
//   // };

//   // const generateSampleExcel = () => {
//   //   const sampleData = [
//   //     {
//   //       name: "Get User Info",
//   //       URL: "https://jsonplaceholder.typicode.com/users/1",
//   //       key: "name",
//   //       method: "GET",
//   //       enable: 1,
//   //     },
//   //     {
//   //       name: "Get Post Details",
//   //       URL: "https://jsonplaceholder.typicode.com/posts/1",
//   //       key: "title",
//   //       method: "GET",
//   //       enable: 1,
//   //     },
//   //     {
//   //       name: "Get Comment for Post",
//   //       URL: "https://jsonplaceholder.typicode.com/comments/1",
//   //       key: "email",
//   //       method: "GET",
//   //       enable: 1,
//   //     },
//   //     {
//   //       name: "Get Todo Item",
//   //       URL: "https://jsonplaceholder.typicode.com/todos/1",
//   //       key: "title",
//   //       method: "GET",
//   //       enable: 1,
//   //     },
//   //     {
//   //       name: "Get Album Info",
//   //       URL: "https://jsonplaceholder.typicode.com/albums/1",
//   //       key: "title",
//   //       method: "GET",
//   //       enable: 1,
//   //     },
//   //     {
//   //       name: "Get Photo Info",
//   //       URL: "https://jsonplaceholder.typicode.com/photos/1",
//   //       key: "url",
//   //       method: "GET",
//   //       enable: 1,
//   //     },
//   //     {
//   //       name: "List All Posts",
//   //       URL: "https://jsonplaceholder.typicode.com/posts",
//   //       key: "length",
//   //       method: "GET",
//   //       enable: 1,
//   //     },
//   //   ];
//   //   const worksheet = XLSX.utils.json_to_sheet(sampleData);
//   //   const workbook = XLSX.utils.book_new();
//   //   XLSX.utils.book_append_sheet(workbook, worksheet, "HTTP Sources");
//   //   XLSX.writeFile(workbook, "HTTP_Sources_Sample.xlsx");
//   // };

//   // const handleSelectAll = (checked) => {
//   //   if (checked) {
//   //     setSelectedRows(sources.data);
//   //   } else {
//   //     setSelectedRows([]);
//   //   }
//   // };

//   // const handleRowSelect = (checked, row) => {
//   //   if (checked) {
//   //     setSelectedRows((prev) => [...prev, row]);
//   //   } else {
//   //     setSelectedRows((prev) => prev.filter((r) => r.id !== row.id));
//   //   }
//   // };

//   const cookies = new Cookie();
//   const isMobile = useMediaQuery("(max-width:900px)");
//   const formRef = useRef(null);

//   // Form state
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [name, setName] = useState("");
//   const [url, setUrl] = useState("");
//   const [key, setKey] = useState("");
//   const [method, setMethod] = useState("GET");
//   const [enable, setEnable] = useState(false);

//   // Edit mode state
//   const [isInEditableMode, setIsInEditableMode] = useState(false);
//   const [editableData, setEditableData] = useState(null);

//   // Other state
//   const [ursource, setUrsource] = useState("0000");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [debouncedSearch, setDebouncedSearch] = useState("");
//   const [messageError, setMessageError] = useState({
//     name: false,
//     url: false,
//     key: false,
//     method: false,
//   });

//   let actionInitiatingUser = "";
//   let userToken = "";

//   try {
//     actionInitiatingUser = parseInt(cookies.get("userID"));
//     userToken = cookies.get("userToken");
//   } catch (error) {}

//   const headers = {
//     Authorization: `Bearer ${userToken}`,
//     "Content-Type": "application/json",
//   };

//   useEffect(() => {
//     setUrsource(decrypt(cookies.get("ursource")));
//   }, []);

//   // Set form values when editing
//   useEffect(() => {
//     if (editableData) {
//       console.log("Setting form for edit:", editableData);
//       setName(editableData.name ?? "");
//       setUrl(editableData.URL ?? "");
//       setKey(editableData.key ?? "");
//       setMethod((editableData.method ?? "GET").toString().toUpperCase());
//       setEnable(editableData.enable ?? false);
//       setIsInEditableMode(true);
//     }
//   }, [editableData]);

//   const {
//     isPending,
//     data: sources,
//     error,
//   } = useFetch({
//     actionInitiatingUser: { userID: actionInitiatingUser },
//     URL: config.BACKEND_URL + "/logger_sources/sources/http",
//   });

//   const [rows, setRows] = useState();

//   useEffect(() => {
//     if (sources) {
//       setRows(sources);
//     }
//   }, [sources]);

//   // Debounce search
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setDebouncedSearch(searchQuery);
//     }, 300);

//     return () => clearTimeout(timer);
//   }, [searchQuery]);

//   // Filter and paginate rows
//   const filteredRows =
//     rows?.data?.filter((row) => {
//       const rowText = Object.values(row)
//         .map((v) => String(v).toLowerCase())
//         .join(" ");
//       return rowText.includes(debouncedSearch.toLowerCase());
//     }) || [];

//   const [currentPage, setCurrentPage] = useState(1);
//   const pageSize = 10;
//   const totalRows = filteredRows?.length;
//   const start = (currentPage - 1) * pageSize;
//   const end = start + pageSize;
//   const totalPages = Math.ceil(totalRows / pageSize);

//   const paginatedRows = filteredRows.slice(start, end);

//   const visibleRows = rows
//     ? { ...rows, data: paginatedRows }
//     : { columns: [], data: [] };

//   const handleDeleteSelected = () => {
//     if (selectedRows.length === 0) return;

//     swal({
//       title: "Are you sure?",
//       text: `Delete ${selectedRows.length} selected source(s)?`,
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     }).then(async (confirmed) => {
//       if (!confirmed) return;

//       const ids = selectedRows.map((row) => row.id);
//       console.log("Deleting IDs:", ids);

//       try {
//         await axios.post(
//           config.BACKEND_URL + "/logger_sources/sources/delete-by-ids",
//           {
//             sourceIDs: ids,
//             actionInitiatingUser,
//           },
//           { headers }
//         );

//         swal("Deleted!", "Selected sources have been removed.", "success");

//         setRows((prev) => ({
//           ...prev,
//           data: prev.data.filter((row) => !ids.includes(row.id)),
//         }));

//         setSelectedRows([]);
//       } catch (err) {
//         console.error(err);
//         swal("Error", "Failed to delete selected sources.", "error");
//       }
//     });
//   };

//   const handleDeleteButton = (e, row) => {
//     e.preventDefault();
//     mixpanel.track("HTTP Delete Button Clicked", {
//       userID: cookies.get("userID"),
//     });

//     if (ursource.charAt(3) !== "1") {
//       swal("No Permission", "You cannot perform delete operation", "error");
//       return;
//     }

//     if (row.length === 0) {
//       swal(
//         "Invalid selection!",
//         "You have not selected any rows for deleting!",
//         "error"
//       );
//     } else {
//       swal({
//         title: "Are you sure?",
//         text: "Do you want to delete the selected sources?",
//         icon: "warning",
//         buttons: true,
//         dangerMode: true,
//       }).then(async (willDelete) => {
//         if (willDelete) {
//           try {
//             await axios
//               .post(
//                 config.BACKEND_URL + "/logger_sources/sources/delete-by-ids",
//                 {
//                   sourceIDs: [row.id],
//                   actionInitiatingUser,
//                 },
//                 { headers }
//               )
//               .then((res) => {
//                 swal(
//                   "Sources deleted successfully!",
//                   "Click on OK to continue...",
//                   "success"
//                 ).then(() => {
//                   setRows((prev) => ({
//                     ...prev,
//                     data: prev.data.filter((r) => r.id !== row.id),
//                   }));

//                   setSelectedRows([]);
//                 });
//               })
//               .catch((err) => {
//                 console.log(err);
//               });
//           } catch (err) {
//             swal(
//               "Error!",
//               "Your selected sources have not been deleted due to a server error!",
//               "error"
//             );
//           }
//         } else {
//           swal(
//             "Cancelled!",
//             "Your selected rows have not been deleted!",
//             "error"
//           );
//         }
//       });
//     }
//   };

//   const resetForm = () => {
//     setName("");
//     setUrl("");
//     setKey("");
//     setMethod("GET");
//     setEnable(false);
//     setEditableData(null);
//     setIsInEditableMode(false);
//   };

//   const handleEditButton = (e, row) => {
//     mixpanel.track("HTTP Edit Button Clicked", {
//       userID: cookies.get("userID"),
//     });

//     if (ursource.charAt(2) !== "1") {
//       swal("No Permission", "You cannot perform edit operation", "error");
//       return;
//     }

//     console.log("Editing Row:", row);
//     setEditableData(row);
//     setIsInEditableMode(true);
//     setMessageError((prev) =>
//       Object.fromEntries(Object.keys(prev).map((key) => [key, false]))
//     );

//     formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
//     formRef.current.style.boxShadow = "0 0 10px #3b82f6";
//     setTimeout(() => {
//       formRef.current.style.boxShadow = "none";
//     }, 1000);
//   };

//   const validate = () => {
//     const newErrors = {
//       name: name.trim() === "",
//       url: url.trim() === "",
//       key: key.trim() === "",
//       method: method.trim() === "",
//     };
//     setMessageError(newErrors);

//     return Object.values(newErrors).every((v) => v === false);
//   };

//   const handleHTTPForm = async (e) => {
//     e.preventDefault();

//     mixpanel.track("HTTP Submit Button Clicked", {
//       userID: cookies.get("userID"),
//     });

//     // Permission Check
//     if (ursource.charAt(2) === "0" || ursource.charAt(1) === "0") {
//       swal(
//         "No Permission",
//         "You cannot perform create/edit operation",
//         "error"
//       );
//       return;
//     }

//     if (!validate()) {
//       console.log("Validation failed");
//       return;
//     }

//     const data = {
//       URL: url,
//       method: method.toUpperCase(),
//       key,
//     };

//     const apiBody = !isInEditableMode
//       ? {
//           name,
//           type: "HTTP",
//           data,
//           enable,
//           actionInitiatingUser,
//         }
//       : {
//           name,
//           URL: url,
//           key,
//           method: method.toUpperCase(),
//           enable,
//           actionInitiatingUser,
//           data,
//         };

//     const actionText = isInEditableMode ? "edit" : "add";

//     swal({
//       title: "Are you sure?",
//       text: `Do you want to ${actionText} this data source?`,
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     }).then(async (confirmed) => {
//       if (!confirmed) {
//         swal(`Data source not ${actionText}ed!`, "", "info");
//         return;
//       }

//       try {
//         if (!isInEditableMode) {
//           // CREATE
//           const res = await axios.post(
//             `${config.BACKEND_URL}/logger_sources/sources/http`,
//             apiBody,
//             { headers }
//           );
//           const newSource = {
//             ...res.data.data,
//             id: res.data.id,
//             name: res.data.name,
//             enable: res.data.enable,
//             type: res.data.type,
//             createdAt: res.data.createdAt,
//             updatedAt: res.data.updatedAt,
//           };

//           swal("Source added successfully!", "", "success");

//           setRows((prev) => ({
//             ...prev,
//             data: [...prev.data, newSource],
//           }));

//           resetForm();
//           setIsInEditableMode(false);
//         } else {
//           // UPDATE
//           const res = await axios.patch(
//             `${config.BACKEND_URL}/logger_sources/sources/http/${editableData.id}`,
//             apiBody,
//             { headers }
//           );
//           swal("Source updated successfully!", "", "success");

//           const updatedSource = {
//             id: editableData.id,
//             name,
//             enable,
//             type: editableData.type,
//             createdAt: editableData.createdAt,
//             updatedAt: new Date().toISOString(),
//             URL: url,
//             key,
//             method: method.toUpperCase(),
//           };

//           setRows((prev) => ({
//             ...prev,
//             data: prev.data.map((r) =>
//               r.id === editableData.id ? updatedSource : r
//             ),
//           }));

//           resetForm();
//           setIsInEditableMode(false);
//         }
//       } catch (err) {
//         console.error(err);
//         swal(
//           "Error!",
//           err.response?.data?.message || "Failed to save the data source.",
//           "error"
//         );
//       }
//     });
//   };

//   const handleCancelForm = (e) => {
//     e.preventDefault();
//     mixpanel.track("HTTP Cancel Button Clicked", {
//       userID: cookies.get("userID"),
//     });
//     resetForm();
//     setIsInEditableMode(false);
//   };

//   // Excel Upload Functionality
//   const handleFileUpload = (event) => {
//     if (ursource.charAt(1) !== "1") {
//       swal("No Permission", "You cannot perform create operation", "error");
//       return;
//     }

//     const file = event.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onload = (e) => {
//       const data = e.target.result;
//       const workbook = XLSX.read(data, { type: "binary" });
//       const sheetName = workbook.SheetNames[0];
//       const worksheet = workbook.Sheets[sheetName];
//       const jsonData = XLSX.utils.sheet_to_json(worksheet);

//       processExcelData(jsonData);
//     };
//     reader.readAsBinaryString(file);
//   };

//   const generateSampleExcel = () => {
//     const sampleData = [
//       {
//         name: "Get User Info",
//         URL: "https://jsonplaceholder.typicode.com/users/1",
//         key: "name",
//         method: "GET",
//         enable: 1,
//       },
//       {
//         name: "Get Post Details",
//         URL: "https://jsonplaceholder.typicode.com/posts/1",
//         key: "title",
//         method: "GET",
//         enable: 1,
//       },
//     ];
//     const worksheet = XLSX.utils.json_to_sheet(sampleData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "HTTP Sources");
//     XLSX.writeFile(workbook, "HTTP_Sources_Sample.xlsx");
//   };

//   const rowKey = (row) =>
//     `${String(row.name).trim().toLowerCase()}|${String(row.URL)
//       .trim()
//       .toString()}|${String(row.method).trim().toUpperCase()}`;

//   const validateRow = (row) => {
//     const requiredColumns = ["name", "URL", "key", "method", "enable"];
//     for (const col of requiredColumns) {
//       if (!row[col] || row[col].toString().trim() === "") {
//         return {
//           valid: false,
//           message: `Missing or empty required field: ${col}`,
//         };
//       }
//     }

//     const method = String(row.method).toUpperCase().trim();
//     if (!["GET", "POST"].includes(method)) {
//       return { valid: false, message: "Method must be GET or POST" };
//     }

//     const enableVal = String(row.enable).toLowerCase().trim();
//     if (!["true", "false", "1", "0"].includes(enableVal)) {
//       return { valid: false, message: "Enable must be true, false, 1, or 0" };
//     }

//     return { valid: true };
//   };

//   const processExcelData = async (jsonData) => {
//     const invalidRows = [];
//     const validRows = [];

//     jsonData.forEach((row, index) => {
//       const validation = validateRow(row);
//       if (validation.valid) {
//         validRows.push({ row, rowIndex: index + 2 });
//       } else {
//         invalidRows.push({
//           rowIndex: index + 2,
//           message: validation.message,
//         });
//       }
//     });

//     if (validRows.length === 0) {
//       swal(
//         "No Valid Rows",
//         "The uploaded file contains no valid rows to add.",
//         "error"
//       );
//       return;
//     }

//     const seen = new Map();
//     const dedupedRows = [];
//     const skippedFileDupes = [];

//     for (const { row, rowIndex } of validRows) {
//       const key = rowKey(row);
//       if (seen.has(key)) {
//         skippedFileDupes.push({
//           rowIndex,
//           message: `Duplicate in file (same as row ${seen.get(key)})`,
//         });
//         continue;
//       }
//       seen.set(key, rowIndex);
//       dedupedRows.push({ row, rowIndex });
//     }

//     const existingKeys = new Set(
//       (sources?.data || [])
//         .map((s) => ({
//           name: String(s.name || "")
//             .trim()
//             .toLowerCase(),
//           URL: String(s.URL || "").trim(),
//           method: String(s.method || "")
//             .trim()
//             .toUpperCase(),
//         }))
//         .map((s) => `${s.name}|${s.URL}|${s.method}`)
//     );

//     const toCreate = [];
//     const skippedExistingDupes = [];

//     for (const { row, rowIndex } of dedupedRows) {
//       const key = rowKey(row);
//       if (existingKeys.has(key)) {
//         skippedExistingDupes.push({
//           rowIndex,
//           message: "Duplicate of an existing HTTP source",
//         });
//         continue;
//       }
//       toCreate.push({ row, rowIndex });
//     }

//     if (toCreate.length === 0) {
//       const msg = [
//         "No rows to upload.",
//         skippedFileDupes.length
//           ? `Skipped ${skippedFileDupes.length} duplicate row(s) within file.`
//           : "",
//         skippedExistingDupes.length
//           ? `Skipped ${skippedExistingDupes.length} duplicate row(s) that already exist.`
//           : "",
//         invalidRows.length
//           ? `Skipped ${invalidRows.length} invalid row(s).`
//           : "",
//       ]
//         .filter(Boolean)
//         .join(" ");
//       swal("Nothing Uploaded", msg, "info");
//       return;
//     }

//     const requests = toCreate.map(({ row }) => {
//       const method = String(row.method).toUpperCase().trim();
//       const enableBool = ["true", "1", 1, true].includes(
//         typeof row.enable === "string"
//           ? row.enable.toLowerCase().trim()
//           : row.enable
//       );

//       const source = {
//         name: row.name,
//         type: "HTTP",
//         data: {
//           URL: row.URL,
//           method,
//           key: row.key,
//         },
//         enable: enableBool,
//         actionInitiatingUser,
//       };

//       return axios.post(
//         `${config.BACKEND_URL}/logger_sources/sources/http`,
//         source,
//         { headers }
//       );
//     });

//     try {
//       const settled = await Promise.allSettled(requests);
//       const successes = settled.filter((r) => r.status === "fulfilled").length;
//       const failures = settled.filter((r) => r.status === "rejected").length;

//       let message = `Uploaded ${successes} source(s).`;
//       if (failures > 0) message += ` Failed ${failures} source(s).`;
//       if (skippedFileDupes.length > 0)
//         message += ` Skipped ${skippedFileDupes.length} duplicate row(s) within file.`;
//       if (skippedExistingDupes.length > 0)
//         message += ` Skipped ${skippedExistingDupes.length} duplicate row(s) already present.`;
//       if (invalidRows.length > 0)
//         message += ` Skipped ${invalidRows.length} invalid row(s).`;

//       swal("Upload Complete", message, "info").then(() =>
//         window.location.reload()
//       );
//     } catch (err) {
//       console.error("Unexpected error during upload:", err);
//       swal(
//         "Error",
//         "An unexpected error occurred while uploading sources.",
//         "error"
//       );
//     }
//   };

//   const handleSelectAll = (checked) => {
//     if (checked) {
//       setSelectedRows(sources.data);
//     } else {
//       setSelectedRows([]);
//     }
//   };

//   const handleRowSelect = (checked, row) => {
//     if (checked) {
//       setSelectedRows((prev) => [...prev, row]);
//     } else {
//       setSelectedRows((prev) => prev.filter((r) => r.id !== row.id));
//     }
//   };

//   return (
//     // <Box sx={{ minHeight: "100vh", bgcolor: "#0f1729" }}>
//     //   <Navbar />

//     <Box
//       sx={{
//         minHeight: "100vh",
//         bgcolor: "#0f1729",
//         pt: { xs: "72px", sm: "80px" }, // 👈 FIX
//       }}
//     >
//       <Navbar />

//       <Box
//         sx={{
//           px: { xs: 2, sm: 3, md: 4 },
//           py: { xs: 2, md: 4 },
//           maxWidth: "1300px",
//           mx: "auto",
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: { xs: "column", md: "row" },
//             justifyContent: "space-between",
//             alignItems: { xs: "flex-start", md: "center" },
//             gap: { xs: 2, md: 0 },
//             mb: { xs: 3, md: 4 },
//           }}
//         >
//           <Box>
//             <Typography
//               variant="h4"
//               sx={{
//                 fontWeight: 700,
//                 color: "white",
//                 fontSize: { xs: "1.6rem", md: "2rem" },
//               }}
//             >
//               HTTP Data Sources
//             </Typography>
//             <Typography
//               sx={{
//                 fontSize: { xs: "0.95rem", md: "1.1rem" },
//                 color: "rgba(255,255,255,0.7)",
//                 mt: 0.5,
//               }}
//             >
//               Manage your HTTP integrations and APIs.
//             </Typography>
//           </Box>

//           <Button
//             variant="outlined"
//             startIcon={<Download size={18} />}
//             onClick={generateSampleExcel}
//             sx={{
//               color: "white",
//               borderColor: "#334155",
//               textTransform: "none",
//               width: { xs: "100%", sm: "auto" },
//               "&:hover": { borderColor: "#60a5fa" },
//             }}
//           >
//             Sample Format
//           </Button>
//         </Box>

//         <Grid container spacing={3}>
//           {/* FORM CARD */}
//           <Grid item xs={12} md={8} id="http-form-section">
//             <Card
//               elevation={0}
//               sx={{
//                 background: "rgba(15, 23, 42, 0.6)",
//                 backdropFilter: "blur(12px)",
//                 WebkitBackdropFilter: "blur(12px)",
//                 color: "white",
//                 borderRadius: "16px",
//                 border: "1px solid rgba(148, 163, 184, 0.15)",
//                 boxShadow:
//                   "0 0 0 1px rgba(255,255,255,0.05), 0 4px 12px rgba(49, 56, 163, 0.4)",
//                 p: { xs: 2, md: 3 },
//               }}
//             >
//               {/* HEADER */}
//               <Box sx={{ mb: 1 }}>
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                   <Plus size={20} color="#60a5fa" />
//                   <Typography
//                     variant="h6"
//                     sx={{
//                       fontWeight: 600,
//                       fontSize: { xs: "1rem", md: "1.1rem" },
//                     }}
//                   >
//                     Add New HTTP Source
//                   </Typography>
//                 </Box>

//                 <Typography
//                   variant="body2"
//                   sx={{ color: "rgba(255,255,255,0.6)", mt: 0.5 }}
//                 >
//                   Configure an HTTP data source.
//                 </Typography>
//               </Box>

//               <Divider sx={{ borderColor: "#1e293b", mb: 3 }} />

//               <CardContent sx={{ p: 0 }}>
//                 <form id="httpForm" onSubmit={handleHTTPForm}>
//                   <Grid container spacing={2}>
//                     {/* Upload Excel */}
//                     <Grid
//                       item
//                       xs={12}
//                       sx={{
//                         display: "flex",
//                         gap: 2,
//                         flexWrap: "wrap",
//                         mb: 1,
//                       }}
//                     >
//                       <Button
//                         variant="outlined"
//                         component="label"
//                         startIcon={<Upload size={16} />}
//                         sx={{
//                           color: "white",
//                           borderColor: "#334155",
//                           borderStyle: "dashed",
//                           bgcolor: "#0f1729",
//                           textTransform: "none",
//                           width: { xs: "100%", sm: "auto" },
//                           "&:hover": {
//                             borderColor: "#60a5fa",
//                             bgcolor: "#1e293b",
//                           },
//                         }}
//                       >
//                         Upload Excel
//                         <input
//                           type="file"
//                           accept=".xlsx, .xls"
//                           hidden
//                           onChange={handleFileUpload}
//                         />
//                       </Button>
//                     </Grid>

//                     {/* Enable dropdown (Replaced Switch) */}

//                     {/* Name */}
//                     <Grid item xs={12} md={6}>
//                       <TextField
//                         id="httpName"
//                         label="Name of the data source"
//                         required
//                         fullWidth
//                         autoComplete="off"
//                         placeholder="Enter name of the data source"
//                         InputLabelProps={{ style: { color: "#94a3b8" } }}
//                         sx={{
//                           input: {
//                             color: "white",
//                             fontWeight: "bold",
//                             fontSize: { xs: "0.9rem", md: "1rem" },
//                           },
//                           "& .MuiOutlinedInput-root": {
//                             "& fieldset": { borderColor: "#334155" },
//                             "&:hover fieldset": { borderColor: "#60a5fa" },
//                           },
//                         }}
//                       />
//                     </Grid>

//                     {/* URL */}
//                     <Grid item xs={12} md={6}>
//                       <TextField
//                         id="httpURL"
//                         label="URL for data retrieval"
//                         required
//                         fullWidth
//                         autoComplete="off"
//                         placeholder="https://api.example.com/data"
//                         InputLabelProps={{ style: { color: "#94a3b8" } }}
//                         sx={{
//                           input: {
//                             color: "white",
//                             fontWeight: "bold",
//                             fontSize: { xs: "0.9rem", md: "1rem" },
//                           },
//                           "& .MuiOutlinedInput-root": {
//                             "& fieldset": { borderColor: "#334155" },
//                             "&:hover fieldset": { borderColor: "#60a5fa" },
//                           },
//                         }}
//                       />
//                     </Grid>

//                     {/* Key */}
//                     <Grid item xs={12} md={6}>
//                       <TextField
//                         id="httpKey"
//                         label="Key for data retrieval"
//                         required
//                         fullWidth
//                         autoComplete="off"
//                         placeholder="Enter response key (e.g. data.items)"
//                         InputLabelProps={{ style: { color: "#94a3b8" } }}
//                         sx={{
//                           input: {
//                             color: "white",
//                             fontWeight: "bold",
//                             fontSize: { xs: "0.9rem", md: "1rem" },
//                           },
//                           "& .MuiOutlinedInput-root": {
//                             "& fieldset": { borderColor: "#334155" },
//                             "&:hover fieldset": { borderColor: "#60a5fa" },
//                           },
//                         }}
//                       />
//                     </Grid>

//                     {/* Method */}
//                     <Grid item xs={12} md={6}>
//                       <Typography
//                         sx={{
//                           mb: 0.5,
//                           fontSize: "0.85rem",
//                           color: "#94a3b8",
//                           fontWeight: 500,
//                         }}
//                       >
//                         Select HTTP method for data retrieval
//                       </Typography>
//                       <Box
//                         sx={{
//                           borderRadius: "8px",
//                           border: "1px solid #334155",
//                           bgcolor: "#020617",
//                           px: 1.5,
//                           py: 0.5,
//                         }}
//                       >
//                         <select
//                           id="httpMethod"
//                           name="method"
//                           style={{
//                             width: "100%",
//                             background: "transparent",
//                             border: "none",
//                             outline: "none",
//                             padding: "8px 0",
//                             color: "white",
//                             fontWeight: "bold",
//                             fontSize: "0.95rem",
//                             appearance: "none",
//                           }}
//                           defaultValue="GET"
//                         >
//                           <option
//                             style={{ color: "black", fontWeight: "bold" }}
//                             value="GET"
//                           >
//                             GET
//                           </option>
//                           <option
//                             style={{ color: "black", fontWeight: "bold" }}
//                             value="POST"
//                           >
//                             POST
//                           </option>
//                         </select>
//                       </Box>
//                     </Grid>

//                     <Grid item xs={12} md={6}>
//                       <Typography
//                         sx={{
//                           mb: 0.5,
//                           fontSize: "0.85rem",
//                           color: "#94a3b8",
//                           fontWeight: 500,
//                         }}
//                       >
//                         Logging Status
//                       </Typography>
//                       <Box
//                         sx={{
//                           borderRadius: "8px",
//                           border: "1px solid #334155",
//                           bgcolor: "#020617",
//                           px: 1.5,
//                           py: 0.5,
//                         }}
//                       >
//                         <select
//                           id="httpEnable"
//                           name="enable"
//                           style={{
//                             width: "100%",
//                             background: "transparent",
//                             border: "none",
//                             outline: "none",
//                             padding: "8px 0",
//                             color: "white",
//                             fontWeight: "bold",
//                             fontSize: "0.95rem",
//                             appearance: "none",
//                           }}
//                           defaultValue="true"
//                         >
//                           <option
//                             style={{ color: "black", fontWeight: "bold" }}
//                             value="true"
//                           >
//                             Enabled
//                           </option>
//                           <option
//                             style={{ color: "black", fontWeight: "bold" }}
//                             value="false"
//                           >
//                             Disabled
//                           </option>
//                         </select>
//                       </Box>
//                     </Grid>

//                     {/* Buttons */}
//                     <Grid item xs={12} sx={{ mt: 2 }}>
//                       <Box
//                         sx={{
//                           display: "flex",
//                           flexDirection: { xs: "column", sm: "row" },
//                           gap: 2,
//                           justifyContent: "flex-end",
//                         }}
//                       >
//                         <Button
//                           id="httpFormSubmit"
//                           type="submit"
//                           variant="contained"
//                           sx={{
//                             bgcolor: "#3b82f6",
//                             color: "white",
//                             px: { xs: 2, sm: 4 },
//                             py: 1.2,
//                             borderRadius: "8px",
//                             textTransform: "none",
//                             width: { xs: "100%", sm: "auto" },
//                             "&:hover": { bgcolor: "#2563eb" },
//                           }}
//                         >
//                           Submit
//                         </Button>
//                         <Button
//                           type="reset"
//                           variant="outlined"
//                           sx={{
//                             borderColor: "#facc15",
//                             color: "#eab308",
//                             textTransform: "none",
//                             width: { xs: "100%", sm: "auto" },
//                             "&:hover": {
//                               borderColor: "#facc15",
//                               bgcolor: "rgba(234,179,8,0.1)",
//                             },
//                           }}
//                         >
//                           Reset
//                         </Button>
//                       </Box>
//                     </Grid>
//                   </Grid>
//                 </form>
//               </CardContent>
//             </Card>
//           </Grid>

//           {/* HELPER CARD / ACCORDION */}
//           <Grid item xs={12} md={4}>
//             {isMobile ? (
//               <Accordion
//                 sx={{
//                   bgcolor: "#1e293b",
//                   color: "white",
//                   borderRadius: "16px",
//                   border: "1px solid #334155",
//                   "&:before": { display: "none" },
//                 }}
//               >
//                 <AccordionSummary
//                   expandIcon={<ChevronDown size={18} color="#cbd5e1" />}
//                 >
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                     <LayoutDashboard size={18} color="#3b82f6" />
//                     <Typography sx={{ fontWeight: 600, fontSize: "0.95rem" }}>
//                       HTTP Source Help
//                     </Typography>
//                   </Box>
//                 </AccordionSummary>
//                 <AccordionDetails>
//                   <CardContent sx={{ p: 0 }}>
//                     <Box display="flex" gap={2} mb={2}>
//                       <Box
//                         sx={{
//                           p: 1.2,
//                           color: "#3b82f6",
//                           bgcolor: "rgba(59,130,246,0.15)",
//                           borderRadius: "50%",
//                           display: "flex",
//                           width: 40,
//                           height: 40,
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         <LayoutDashboard size={18} />
//                       </Box>

//                       <Box>
//                         <Typography fontWeight={600} fontSize="0.95rem">
//                           Need help configuring?
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "rgba(255,255,255,0.6)" }}
//                         >
//                           Ensure your HTTP endpoint is reachable and responds
//                           with JSON. Use keys like <code>data</code> or{" "}
//                           <code>items[0].value</code> to extract metrics.
//                         </Typography>
//                       </Box>
//                     </Box>

//                     <Divider sx={{ mb: 2, borderColor: "#334155" }} />

//                     <Box display="flex" gap={2}>
//                       <Box
//                         sx={{
//                           p: 1.2,
//                           color: "#3b82f6",
//                           bgcolor: "rgba(59,130,246,0.15)",
//                           borderRadius: "50%",
//                           display: "flex",
//                           width: 40,
//                           height: 40,
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         <Database size={18} />
//                       </Box>

//                       <Box>
//                         <Typography fontWeight={600} fontSize="0.95rem">
//                           Sample Configuration
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "rgba(255,255,255,0.6)" }}
//                         >
//                           URL:{" "}
//                           <code>
//                             https://jsonplaceholder.typicode.com/posts/1
//                           </code>
//                           <br />
//                           Method: <code>GET</code>
//                           <br />
//                           Key: <code>title</code>
//                         </Typography>
//                       </Box>
//                     </Box>
//                   </CardContent>
//                 </AccordionDetails>
//               </Accordion>
//             ) : (
//               <Card
//                 sx={{
//                   bgcolor: "#1e293b",
//                   color: "white",
//                   borderRadius: "16px",
//                   border: "1px solid #334155",
//                   p: 2,
//                 }}
//               >
//                 <CardContent>
//                   {/* Block 1 */}
//                   <Box display="flex" gap={2} mb={2}>
//                     <Box
//                       sx={{
//                         p: 1.2,
//                         color: "#3b82f6",
//                         bgcolor: "rgba(59,130,246,0.15)",
//                         borderRadius: "50%",
//                         display: "flex",
//                         width: 45,
//                         height: 45,
//                         alignItems: "center",
//                         justifyContent: "center",
//                       }}
//                     >
//                       <LayoutDashboard size={20} />
//                     </Box>

//                     <Box>
//                       <Typography fontWeight={600}>
//                         Need help configuring?
//                       </Typography>
//                       <Typography
//                         variant="body2"
//                         sx={{ color: "rgba(255,255,255,0.6)" }}
//                       >
//                         Ensure your HTTP endpoint is reachable and responds with
//                         JSON. Use keys like <code>data</code> or{" "}
//                         <code>items[0].value</code> to extract metrics.
//                       </Typography>
//                     </Box>
//                   </Box>

//                   <Divider sx={{ mb: 2, borderColor: "#334155" }} />

//                   {/* Block 2 */}
//                   <Box display="flex" gap={2}>
//                     <Box
//                       sx={{
//                         p: 1.2,
//                         color: "#3b82f6",
//                         bgcolor: "rgba(59,130,246,0.15)",
//                         borderRadius: "50%",
//                         display: "flex",
//                         width: 45,
//                         height: 45,
//                         alignItems: "center",
//                         justifyContent: "center",
//                       }}
//                     >
//                       <Database size={20} />
//                     </Box>

//                     <Box>
//                       <Typography fontWeight={600}>
//                         Sample Configuration
//                       </Typography>
//                       <Typography
//                         variant="body2"
//                         sx={{ color: "rgba(255,255,255,0.6)" }}
//                       >
//                         URL:{" "}
//                         <code>
//                           https://jsonplaceholder.typicode.com/posts/1
//                         </code>
//                         <br />
//                         Method: <code>GET</code>
//                         <br />
//                         Key: <code>title</code>
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </CardContent>
//               </Card>
//             )}
//           </Grid>
//         </Grid>

//         {/* TABLE SECTION */}
//         {ursource.charAt(0) === "1" && (
//           <Card
//             sx={{
//               mt: 4,
//               bgcolor: "#0f1729",
//               color: "white",
//               borderRadius: "16px",
//               border: "1px solid #1e293b",
//               p: { xs: 2, md: 3 },
//             }}
//           >
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: { xs: "flex-start", sm: "center" },
//                 flexDirection: { xs: "column", sm: "row" },
//                 gap: { xs: 1, sm: 0 },
//                 mb: 2,
//               }}
//             >
//               <Typography
//                 variant="h6"
//                 sx={{
//                   fontWeight: 600,
//                   fontSize: { xs: "1rem", md: "1.1rem" },
//                 }}
//               >
//                 Current HTTP Data Sources
//               </Typography>
//             </Box>

//             {isPending && (
//               <Box
//                 sx={{
//                   py: 6,
//                   textAlign: "center",
//                   color: "rgba(148,163,184,0.9)",
//                 }}
//               >
//                 <Typography variant="h6">Loading...</Typography>
//               </Box>
//             )}

//             {error && !isPending && (
//               <Box
//                 sx={{
//                   py: 6,
//                   textAlign: "center",
//                   color: "rgba(248,113,113,0.9)",
//                 }}
//               >
//                 <Typography variant="h6">
//                   Cannot fetch the data right now!
//                 </Typography>
//               </Box>
//             )}

//             {!isPending && !error && sources && sources.data && (
//               <>
//                 {/* Delete All Button - appears when all rows selected */}
//                 {selectedRows.length === sources.data.length &&
//                   sources.data.length > 0 && (
//                     <Box
//                       sx={{
//                         mb: 3,
//                         p: 2,
//                         bgcolor: "rgba(239, 68, 68, 0.1)",
//                         border: "2px solid #ef4444",
//                         borderRadius: "12px",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "space-between",
//                         flexDirection: { xs: "column", sm: "row" },
//                         gap: 2,
//                       }}
//                     >
//                       <Box
//                         sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
//                       >
//                         <Box
//                           sx={{
//                             width: 40,
//                             height: 40,
//                             borderRadius: "50%",
//                             bgcolor: "rgba(239, 68, 68, 0.2)",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                           }}
//                         >
//                           <Trash2 size={20} color="#ef4444" />
//                         </Box>
//                         <Box>
//                           <Typography
//                             sx={{ fontWeight: 600, color: "#fca5a5" }}
//                           >
//                             All {sources.data.length} sources selected
//                           </Typography>
//                           <Typography
//                             variant="body2"
//                             sx={{ color: "rgba(252, 165, 165, 0.8)" }}
//                           >
//                             You're about to delete all HTTP data sources
//                           </Typography>
//                         </Box>
//                       </Box>
//                       <Button
//                         variant="contained"
//                         startIcon={<Trash2 size={18} />}
//                         onClick={handleDeleteButton}
//                         sx={{
//                           bgcolor: "#ef4444",
//                           color: "white",
//                           textTransform: "none",
//                           fontWeight: 600,
//                           px: 3,
//                           py: 1,
//                           width: { xs: "100%", sm: "auto" },
//                           "&:hover": {
//                             bgcolor: "#dc2626",
//                           },
//                         }}
//                       >
//                         Delete All Sources
//                       </Button>
//                     </Box>
//                   )}

//                 {sources.data.length === 0 ? (
//                   <Box
//                     sx={{
//                       py: 8,
//                       display: "flex",
//                       flexDirection: "column",
//                       justifyContent: "center",
//                       alignItems: "center",
//                       color: "rgba(148,163,184,0.8)",
//                       textAlign: "center",
//                     }}
//                   >
//                     <Database size={60} color="#64748b" />
//                     <Typography
//                       variant="h6"
//                       sx={{
//                         mt: 2,
//                         fontWeight: 500,
//                         color: "#cbd5e1",
//                         fontSize: { xs: "1rem", md: "1.1rem" },
//                       }}
//                     >
//                       Currently, there are no HTTP data sources!
//                     </Typography>
//                     <Typography
//                       variant="body2"
//                       sx={{
//                         mt: 1,
//                         color: "rgba(148,163,184,0.8)",
//                         fontSize: { xs: "0.85rem", md: "0.9rem" },
//                       }}
//                     >
//                       Add your first HTTP source using the form above.
//                     </Typography>
//                   </Box>
//                 ) : (
//                   <Box
//                     sx={{
//                       overflowX: "auto",
//                     }}
//                   >
//                     <Box sx={{ overflowX: "auto" }}>
//                       <MuiTable
//                         sx={{
//                           minWidth: 900,
//                           bgcolor: "#0f1729",
//                           borderRadius: "12px",
//                         }}
//                       >
//                         <TableHead>
//                           <TableRow
//                             sx={{
//                               bgcolor: "#1e293b",
//                               "& th": {
//                                 color: "#94a3b8",
//                                 fontWeight: 600,
//                                 borderBottom: "1px solid #334155",
//                               },
//                             }}
//                           >
//                             <TableCell padding="checkbox">
//                               <Checkbox
//                                 checked={
//                                   selectedRows.length === sources.data.length &&
//                                   sources.data.length > 0
//                                 }
//                                 indeterminate={
//                                   selectedRows.length > 0 &&
//                                   selectedRows.length < sources.data.length
//                                 }
//                                 onChange={(e) =>
//                                   handleSelectAll(e.target.checked)
//                                 }
//                               />
//                             </TableCell>

//                             {sources.columns.map((col) => (
//                               <TableCell key={col.field}>{col.title}</TableCell>
//                             ))}

//                             <TableCell align="right">Actions</TableCell>
//                           </TableRow>
//                         </TableHead>

//                         <TableBody>
//                           {sources.data.map((row) => (
//                             <TableRow
//                               key={row.id}
//                               sx={{
//                                 "& td": {
//                                   color: "#e2e8f0",
//                                   borderBottom: "1px solid #1e293b",
//                                 },
//                                 "&:hover": {
//                                   backgroundColor: "rgba(255,255,255,0.03)",
//                                 },
//                               }}
//                             >
//                               <TableCell padding="checkbox">
//                                 <Checkbox
//                                   checked={selectedRows.some(
//                                     (r) => r.id === row.id
//                                   )}
//                                   onChange={(e) =>
//                                     handleRowSelect(e.target.checked, row)
//                                   }
//                                 />
//                               </TableCell>

//                               {sources.columns.map((col) => (
//                                 <TableCell key={col.field}>
//                                   {col.field === "enable" ? (
//                                     <Chip
//                                       label={row.enable ? "Active" : "Inactive"}
//                                       color={row.enable ? "success" : "error"}
//                                       size="small"
//                                     />
//                                   ) : (
//                                     row[col.field]
//                                   )}
//                                 </TableCell>
//                               ))}

//                               <TableCell align="right">
//                                 {ursource.charAt(2) === "1" && (
//                                   <IconButton
//                                     onClick={() => {
//                                       setSelectedRows([row]);
//                                       setTimeout(
//                                         () =>
//                                           handleEditButton(new Event("click")),
//                                         0
//                                       );
//                                     }}
//                                     sx={{ color: "#64748b" }}
//                                   >
//                                     <Edit2 size={18} />
//                                   </IconButton>
//                                 )}

//                                 {ursource.charAt(3) === "1" && (
//                                   <IconButton
//                                     onClick={(e) => {
//                                       setSelectedRows([row]);
//                                       setTimeout(
//                                         () => handleDeleteButton(e),
//                                         0
//                                       );
//                                     }}
//                                     sx={{ color: "#64748b" }}
//                                   >
//                                     <Trash2 size={18} />
//                                   </IconButton>
//                                 )}
//                               </TableCell>
//                             </TableRow>
//                           ))}
//                         </TableBody>
//                       </MuiTable>
//                     </Box>
//                   </Box>
//                 )}
//               </>
//             )}
//           </Card>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default HTTPSources;

import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import swal from "sweetalert";
import Cookie from "universal-cookie";
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
  Grid,
  Divider,
  Checkbox,
  IconButton,
  Chip,
  InputAdornment,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table as MuiTable,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  useMediaQuery,
} from "@mui/material";
import {
  Plus,
  Upload,
  Download,
  Edit2,
  Trash2,
  Database,
  LayoutDashboard,
  ChevronDown,
  Search,
} from "lucide-react";
import mixpanel from "mixpanel-browser";
import config from "../config";
import { decrypt } from "./useCryptoJS";
import useFetch from "./useFetch";
import Navbar from "../components/Navbar";

const HTTPSources = (props) => {
  const cookies = new Cookie();
  const isMobile = useMediaQuery("(max-width:900px)");
  const formRef = useRef(null);

  // Form state
  const [selectedRows, setSelectedRows] = useState([]);
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");
  const [key, setKey] = useState("");
  const [method, setMethod] = useState("GET");
  const [enable, setEnable] = useState(true);

  // Edit mode state
  const [isInEditableMode, setIsInEditableMode] = useState(false);
  const [editableData, setEditableData] = useState(null);

  // Other state
  const [ursource, setUrsource] = useState("0000");
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [messageError, setMessageError] = useState({
    name: false,
    url: false,
    key: false,
    method: false,
  });

  let actionInitiatingUser = "";
  let userToken = "";

  try {
    actionInitiatingUser = parseInt(cookies.get("userID"));
    userToken = cookies.get("userToken");
  } catch (error) {}

  const headers = {
    Authorization: `Bearer ${userToken}`,
    "Content-Type": "application/json",
  };

  useEffect(() => {
    setUrsource(decrypt(cookies.get("ursource")));
  }, []);

  // Set form values when editing
  useEffect(() => {
    if (editableData) {
      console.log("Setting form for edit:", editableData);
      setName(editableData.name ?? "");
      setUrl(editableData.URL ?? "");
      setKey(editableData.key ?? "");
      setMethod((editableData.method ?? "GET").toString().toUpperCase());

      const isEnabled =
        editableData.enable === true ||
        editableData.enable === 1 ||
        editableData.enable === "1" ||
        editableData.enable === "true";
      setEnable(isEnabled);

      setIsInEditableMode(true);
    }
  }, [editableData]);

  const {
    isPending,
    data: sources,
    error,
  } = useFetch({
    actionInitiatingUser: { userID: actionInitiatingUser },
    URL: config.BACKEND_URL + "/logger_sources/sources/http",
  });

  const [rows, setRows] = useState();

  useEffect(() => {
    if (sources) {
      setRows(sources);
    }
  }, [sources]);

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  // Filter and paginate rows
  const filteredRows =
    rows?.data?.filter((row) => {
      const rowText = Object.values(row)
        .map((v) => String(v).toLowerCase())
        .join(" ");
      return rowText.includes(debouncedSearch.toLowerCase());
    }) || [];

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const totalRows = filteredRows?.length;
  const start = (currentPage - 1) * pageSize;
  const end = start + pageSize;
  const totalPages = Math.ceil(totalRows / pageSize);

  const paginatedRows = filteredRows.slice(start, end);

  const visibleRows = rows
    ? { ...rows, data: paginatedRows }
    : { columns: [], data: [] };

  const handleDeleteSelected = () => {
    if (selectedRows.length === 0) return;

    swal({
      title: "Are you sure?",
      text: `Delete ${selectedRows.length} selected source(s)?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (confirmed) => {
      if (!confirmed) return;

      const ids = selectedRows.map((row) => row.id);
      console.log("Deleting IDs:", ids);

      try {
        await axios.post(
          config.BACKEND_URL + "/logger_sources/sources/delete-by-ids",
          {
            sourceIDs: ids,
            actionInitiatingUser,
          },
          { headers }
        );

        swal("Deleted!", "Selected sources have been removed.", "success");

        setRows((prev) => ({
          ...prev,
          data: prev.data.filter((row) => !ids.includes(row.id)),
        }));

        setSelectedRows([]);
      } catch (err) {
        console.error(err);
        swal("Error", "Failed to delete selected sources.", "error");
      }
    });
  };

  const handleDeleteButton = (e, row) => {
    e.preventDefault();
    mixpanel.track("HTTP Delete Button Clicked", {
      userID: cookies.get("userID"),
    });

    if (ursource.charAt(3) !== "1") {
      swal("No Permission", "You cannot perform delete operation", "error");
      return;
    }

    if (row.length === 0) {
      swal(
        "Invalid selection!",
        "You have not selected any rows for deleting!",
        "error"
      );
    } else {
      swal({
        title: "Are you sure?",
        text: "Do you want to delete the selected sources?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          try {
            await axios
              .post(
                config.BACKEND_URL + "/logger_sources/sources/delete-by-ids",
                {
                  sourceIDs: [row.id],
                  actionInitiatingUser,
                },
                { headers }
              )
              .then((res) => {
                swal(
                  "Sources deleted successfully!",
                  "Click on OK to continue...",
                  "success"
                ).then(() => {
                  setRows((prev) => ({
                    ...prev,
                    data: prev.data.filter((r) => r.id !== row.id),
                  }));

                  setSelectedRows([]);
                });
              })
              .catch((err) => {
                console.log(err);
              });
          } catch (err) {
            swal(
              "Error!",
              "Your selected sources have not been deleted due to a server error!",
              "error"
            );
          }
        } else {
          swal(
            "Cancelled!",
            "Your selected rows have not been deleted!",
            "error"
          );
        }
      });
    }
  };

  const resetForm = () => {
    setName("");
    setUrl("");
    setKey("");
    setMethod("GET");
    setEnable(true);
    setEditableData(null);
    setIsInEditableMode(false);
    setMessageError({
      name: false,
      url: false,
      key: false,
      method: false,
    });
  };

  const handleEditButton = (e, row) => {
    mixpanel.track("HTTP Edit Button Clicked", {
      userID: cookies.get("userID"),
    });

    if (ursource.charAt(2) !== "1") {
      swal("No Permission", "You cannot perform edit operation", "error");
      return;
    }

    console.log("Editing Row:", row);
    setEditableData(row);
    setIsInEditableMode(true);
    setMessageError({
      name: false,
      url: false,
      key: false,
      method: false,
    });

    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    if (formRef.current) {
      formRef.current.style.boxShadow = "0 0 10px #3b82f6";
      setTimeout(() => {
        formRef.current.style.boxShadow = "none";
      }, 1000);
    }
  };

  const validate = () => {
    const newErrors = {
      name: name.trim() === "",
      url: url.trim() === "",
      key: key.trim() === "",
      method: method.trim() === "",
    };
    setMessageError(newErrors);

    return Object.values(newErrors).every((v) => v === false);
  };

  const handleHTTPForm = async (e) => {
    e.preventDefault();

    mixpanel.track("HTTP Submit Button Clicked", {
      userID: cookies.get("userID"),
    });

    // Permission Check
    if (ursource.charAt(2) === "0" && ursource.charAt(1) === "0") {
      swal(
        "No Permission",
        "You cannot perform create/edit operation",
        "error"
      );
      return;
    }

    if (!validate()) {
      console.log("Validation failed");
      return;
    }

    const data = {
      URL: url,
      method: method.toUpperCase(),
      key,
    };

    const apiBody = !isInEditableMode
      ? {
          name,
          type: "HTTP",
          data,
          enable,
          actionInitiatingUser,
        }
      : {
          name,
          URL: url,
          key,
          method: method.toUpperCase(),
          enable,
          actionInitiatingUser,
        };

    const actionText = isInEditableMode ? "edit" : "add";

    swal({
      title: "Are you sure?",
      text: `Do you want to ${actionText} this data source?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (confirmed) => {
      if (!confirmed) {
        swal(`Data source not ${actionText}ed!`, "", "info");
        return;
      }

      try {
        if (!isInEditableMode) {
          // CREATE
          const res = await axios.post(
            `${config.BACKEND_URL}/logger_sources/sources/http`,
            apiBody,
            { headers }
          );
          const newSource = {
            ...res.data.data,
            id: res.data.id,
            name: res.data.name,
            enable: res.data.enable,
            type: res.data.type,
            createdAt: res.data.createdAt,
            updatedAt: res.data.updatedAt,
          };

          swal("Source added successfully!", "", "success");

          setRows((prev) => ({
            ...prev,
            data: [...prev.data, newSource],
          }));

          resetForm();
          setIsInEditableMode(false);
        } else {
          // UPDATE
          const res = await axios.patch(
            `${config.BACKEND_URL}/logger_sources/sources/http/${editableData.id}`,
            apiBody,
            { headers }
          );
          swal("Source updated successfully!", "", "success");

          const updatedSource = {
            id: editableData.id,
            name,
            enable,
            type: editableData.type,
            createdAt: editableData.createdAt,
            updatedAt: new Date().toISOString(),
            URL: url,
            key,
            method: method.toUpperCase(),
          };

          setRows((prev) => ({
            ...prev,
            data: prev.data.map((r) =>
              r.id === editableData.id ? updatedSource : r
            ),
          }));

          resetForm();
          setIsInEditableMode(false);
        }
      } catch (err) {
        console.error(err);
        swal(
          "Error!",
          err.response?.data?.message || "Failed to save the data source.",
          "error"
        );
      }
    });
  };

  const handleCancelForm = (e) => {
    e.preventDefault();
    mixpanel.track("HTTP Cancel Button Clicked", {
      userID: cookies.get("userID"),
    });
    resetForm();
    setIsInEditableMode(false);
  };

  // Excel Upload Functionality
  const handleFileUpload = (event) => {
    if (ursource.charAt(1) !== "1") {
      swal("No Permission", "You cannot perform create operation", "error");
      return;
    }

    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      processExcelData(jsonData);
    };
    reader.readAsBinaryString(file);
  };

  const generateSampleExcel = () => {
    const sampleData = [
      {
        name: "Get User Info",
        URL: "https://jsonplaceholder.typicode.com/users/1",
        key: "name",
        method: "GET",
        enable: 1,
      },
      {
        name: "Get Post Details",
        URL: "https://jsonplaceholder.typicode.com/posts/1",
        key: "title",
        method: "GET",
        enable: 1,
      },
    ];
    const worksheet = XLSX.utils.json_to_sheet(sampleData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "HTTP Sources");
    XLSX.writeFile(workbook, "HTTP_Sources_Sample.xlsx");
  };

  const rowKey = (row) =>
    `${String(row.name).trim().toLowerCase()}|${String(row.URL)
      .trim()
      .toString()}|${String(row.method).trim().toUpperCase()}`;

  const validateRow = (row) => {
    const requiredColumns = ["name", "URL", "key", "method", "enable"];
    for (const col of requiredColumns) {
      if (!row[col] || row[col].toString().trim() === "") {
        return {
          valid: false,
          message: `Missing or empty required field: ${col}`,
        };
      }
    }

    const method = String(row.method).toUpperCase().trim();
    if (!["GET", "POST"].includes(method)) {
      return { valid: false, message: "Method must be GET or POST" };
    }

    const enableVal = String(row.enable).toLowerCase().trim();
    if (!["true", "false", "1", "0"].includes(enableVal)) {
      return { valid: false, message: "Enable must be true, false, 1, or 0" };
    }

    return { valid: true };
  };

  const processExcelData = async (jsonData) => {
    const invalidRows = [];
    const validRows = [];

    jsonData.forEach((row, index) => {
      const validation = validateRow(row);
      if (validation.valid) {
        validRows.push({ row, rowIndex: index + 2 });
      } else {
        invalidRows.push({
          rowIndex: index + 2,
          message: validation.message,
        });
      }
    });

    if (validRows.length === 0) {
      swal(
        "No Valid Rows",
        "The uploaded file contains no valid rows to add.",
        "error"
      );
      return;
    }

    const seen = new Map();
    const dedupedRows = [];
    const skippedFileDupes = [];

    for (const { row, rowIndex } of validRows) {
      const key = rowKey(row);
      if (seen.has(key)) {
        skippedFileDupes.push({
          rowIndex,
          message: `Duplicate in file (same as row ${seen.get(key)})`,
        });
        continue;
      }
      seen.set(key, rowIndex);
      dedupedRows.push({ row, rowIndex });
    }

    const existingKeys = new Set(
      (sources?.data || [])
        .map((s) => ({
          name: String(s.name || "")
            .trim()
            .toLowerCase(),
          URL: String(s.URL || "").trim(),
          method: String(s.method || "")
            .trim()
            .toUpperCase(),
        }))
        .map((s) => `${s.name}|${s.URL}|${s.method}`)
    );

    const toCreate = [];
    const skippedExistingDupes = [];

    for (const { row, rowIndex } of dedupedRows) {
      const key = rowKey(row);
      if (existingKeys.has(key)) {
        skippedExistingDupes.push({
          rowIndex,
          message: "Duplicate of an existing HTTP source",
        });
        continue;
      }
      toCreate.push({ row, rowIndex });
    }

    if (toCreate.length === 0) {
      const msg = [
        "No rows to upload.",
        skippedFileDupes.length
          ? `Skipped ${skippedFileDupes.length} duplicate row(s) within file.`
          : "",
        skippedExistingDupes.length
          ? `Skipped ${skippedExistingDupes.length} duplicate row(s) that already exist.`
          : "",
        invalidRows.length
          ? `Skipped ${invalidRows.length} invalid row(s).`
          : "",
      ]
        .filter(Boolean)
        .join(" ");
      swal("Nothing Uploaded", msg, "info");
      return;
    }

    const requests = toCreate.map(({ row }) => {
      const method = String(row.method).toUpperCase().trim();
      const enableBool = ["true", "1", 1, true].includes(
        typeof row.enable === "string"
          ? row.enable.toLowerCase().trim()
          : row.enable
      );

      const source = {
        name: row.name,
        type: "HTTP",
        data: {
          URL: row.URL,
          method,
          key: row.key,
        },
        enable: enableBool,
        actionInitiatingUser,
      };

      return axios.post(
        `${config.BACKEND_URL}/logger_sources/sources/http`,
        source,
        { headers }
      );
    });

    try {
      const settled = await Promise.allSettled(requests);
      const successes = settled.filter((r) => r.status === "fulfilled").length;
      const failures = settled.filter((r) => r.status === "rejected").length;

      let message = `Uploaded ${successes} source(s).`;
      if (failures > 0) message += ` Failed ${failures} source(s).`;
      if (skippedFileDupes.length > 0)
        message += ` Skipped ${skippedFileDupes.length} duplicate row(s) within file.`;
      if (skippedExistingDupes.length > 0)
        message += ` Skipped ${skippedExistingDupes.length} duplicate row(s) already present.`;
      if (invalidRows.length > 0)
        message += ` Skipped ${invalidRows.length} invalid row(s).`;

      swal("Upload Complete", message, "info").then(() =>
        window.location.reload()
      );
    } catch (err) {
      console.error("Unexpected error during upload:", err);
      swal(
        "Error",
        "An unexpected error occurred while uploading sources.",
        "error"
      );
    }
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedRows(rows.data);
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (checked, row) => {
    if (checked) {
      setSelectedRows((prev) => [...prev, row]);
    } else {
      setSelectedRows((prev) => prev.filter((r) => r.id !== row.id));
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#0f1729",
        pt: { xs: "72px", sm: "80px" },
      }}
    >
      <Navbar />

      <Box
        sx={{
          px: { xs: 2, sm: 3, md: 4 },
          py: { xs: 2, md: 4 },
          maxWidth: "1300px",
          mx: "auto",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", md: "center" },
            gap: { xs: 2, md: 0 },
            mb: { xs: 3, md: 4 },
          }}
        >
          <Box>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: "white",
                fontSize: { xs: "1.6rem", md: "2rem" },
              }}
            >
              HTTP Data Sources
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "0.95rem", md: "1.1rem" },
                color: "rgba(255,255,255,0.7)",
                mt: 0.5,
              }}
            >
              Manage your HTTP integrations and APIs.
            </Typography>
          </Box>

          <Button
            variant="outlined"
            startIcon={<Download size={18} />}
            onClick={generateSampleExcel}
            sx={{
              color: "white",
              borderColor: "#334155",
              textTransform: "none",
              width: { xs: "100%", sm: "auto" },
              "&:hover": { borderColor: "#60a5fa" },
            }}
          >
            Sample Format
          </Button>
        </Box>

        <Grid container spacing={3}>
          {/* FORM CARD */}
          <Grid item xs={12} md={8} id="http-form-section">
            <Card
              ref={formRef}
              elevation={0}
              sx={{
                background: "rgba(15, 23, 42, 0.6)",
                backdropFilter: "blur(12px)",
                WebkitBackdropFilter: "blur(12px)",
                color: "white",
                borderRadius: "16px",
                border: "1px solid rgba(148, 163, 184, 0.15)",
                boxShadow:
                  "0 0 0 1px rgba(255,255,255,0.05), 0 4px 12px rgba(49, 56, 163, 0.4)",
                p: { xs: 2, md: 3 },
              }}
            >
              {/* HEADER */}
              <Box sx={{ mb: 1 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Plus size={20} color="#60a5fa" />
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      fontSize: { xs: "1rem", md: "1.1rem" },
                    }}
                  >
                    {isInEditableMode
                      ? "Update HTTP Source"
                      : "Add New HTTP Source"}
                  </Typography>
                </Box>

                <Typography
                  variant="body2"
                  sx={{ color: "rgba(255,255,255,0.6)", mt: 0.5 }}
                >
                  Configure an HTTP data source.
                </Typography>
              </Box>

              <Divider sx={{ borderColor: "#1e293b", mb: 3 }} />

              <CardContent sx={{ p: 0 }}>
                <form id="httpForm" onSubmit={handleHTTPForm}>
                  <Grid container spacing={2}>
                    {/* Upload Excel */}
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: "flex",
                        gap: 2,
                        flexWrap: "wrap",
                        mb: 1,
                      }}
                    >
                      <Button
                        variant="outlined"
                        component="label"
                        startIcon={<Upload size={16} />}
                        sx={{
                          color: "white",
                          borderColor: "#334155",
                          borderStyle: "dashed",
                          bgcolor: "#0f1729",
                          textTransform: "none",
                          width: { xs: "100%", sm: "auto" },
                          "&:hover": {
                            borderColor: "#60a5fa",
                            bgcolor: "#1e293b",
                          },
                        }}
                      >
                        Upload Excel
                        <input
                          type="file"
                          accept=".xlsx, .xls"
                          hidden
                          onChange={handleFileUpload}
                        />
                      </Button>
                    </Grid>

                    {/* Name */}
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Name of the data source"
                        required
                        fullWidth
                        autoComplete="off"
                        placeholder="Enter name of the data source"
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value);
                          setMessageError((prev) => ({
                            ...prev,
                            name: e.target.value.trim() === "",
                          }));
                        }}
                        error={messageError.name}
                        helperText={messageError.name ? "Name is required" : ""}
                        InputLabelProps={{ style: { color: "#94a3b8" } }}
                        sx={{
                          input: {
                            color: "white",
                            fontWeight: "bold",
                            fontSize: { xs: "0.9rem", md: "1rem" },
                          },
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": { borderColor: "#334155" },
                            "&:hover fieldset": { borderColor: "#60a5fa" },
                          },
                        }}
                      />
                    </Grid>

                    {/* URL */}
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="URL for data retrieval"
                        required
                        fullWidth
                        autoComplete="off"
                        placeholder="https://api.example.com/data"
                        value={url}
                        onChange={(e) => {
                          setUrl(e.target.value);
                          setMessageError((prev) => ({
                            ...prev,
                            url: e.target.value.trim() === "",
                          }));
                        }}
                        error={messageError.url}
                        helperText={messageError.url ? "URL is required" : ""}
                        InputLabelProps={{ style: { color: "#94a3b8" } }}
                        sx={{
                          input: {
                            color: "white",
                            fontWeight: "bold",
                            fontSize: { xs: "0.9rem", md: "1rem" },
                          },
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": { borderColor: "#334155" },
                            "&:hover fieldset": { borderColor: "#60a5fa" },
                          },
                        }}
                      />
                    </Grid>

                    {/* Key */}
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Key for data retrieval"
                        required
                        fullWidth
                        autoComplete="off"
                        placeholder="Enter response key (e.g. data.items)"
                        value={key}
                        onChange={(e) => {
                          setKey(e.target.value);
                          setMessageError((prev) => ({
                            ...prev,
                            key: e.target.value.trim() === "",
                          }));
                        }}
                        error={messageError.key}
                        helperText={messageError.key ? "Key is required" : ""}
                        InputLabelProps={{ style: { color: "#94a3b8" } }}
                        sx={{
                          input: {
                            color: "white",
                            fontWeight: "bold",
                            fontSize: { xs: "0.9rem", md: "1rem" },
                          },
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": { borderColor: "#334155" },
                            "&:hover fieldset": { borderColor: "#60a5fa" },
                          },
                        }}
                      />
                    </Grid>

                    {/* Method */}
                    <Grid item xs={12} md={6}>
                      <Typography
                        sx={{
                          mb: 0.5,
                          fontSize: "0.85rem",
                          color: "#94a3b8",
                          fontWeight: 500,
                        }}
                      >
                        Select HTTP method for data retrieval
                      </Typography>
                      <Box
                        sx={{
                          borderRadius: "8px",
                          border: "1px solid #334155",
                          bgcolor: "#020617",
                          px: 1.5,
                          py: 0.5,
                        }}
                      >
                        <select
                          name="method"
                          style={{
                            width: "100%",
                            background: "transparent",
                            border: "none",
                            outline: "none",
                            padding: "8px 0",
                            color: "white",
                            fontWeight: "bold",
                            fontSize: "0.95rem",
                            appearance: "none",
                          }}
                          value={method}
                          onChange={(e) => setMethod(e.target.value)}
                        >
                          <option
                            style={{ color: "black", fontWeight: "bold" }}
                            value="GET"
                          >
                            GET
                          </option>
                          <option
                            style={{ color: "black", fontWeight: "bold" }}
                            value="POST"
                          >
                            POST
                          </option>
                        </select>
                      </Box>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography
                        sx={{
                          mb: 0.5,
                          fontSize: "0.85rem",
                          color: "#94a3b8",
                          fontWeight: 500,
                        }}
                      >
                        Logging Status
                      </Typography>
                      <Box
                        sx={{
                          borderRadius: "8px",
                          border: "1px solid #334155",
                          bgcolor: "#020617",
                          px: 1.5,
                          py: 0.5,
                        }}
                      >
                        <select
                          name="enable"
                          style={{
                            width: "100%",
                            background: "transparent",
                            border: "none",
                            outline: "none",
                            padding: "8px 0",
                            color: "white",
                            fontWeight: "bold",
                            fontSize: "0.95rem",
                            appearance: "none",
                          }}
                          value={enable ? "true" : "false"}
                          onChange={(e) => setEnable(e.target.value === "true")}
                        >
                          <option
                            style={{ color: "black", fontWeight: "bold" }}
                            value="true"
                          >
                            Enabled
                          </option>
                          <option
                            style={{ color: "black", fontWeight: "bold" }}
                            value="false"
                          >
                            Disabled
                          </option>
                        </select>
                      </Box>
                    </Grid>

                    {/* Buttons */}
                    <Grid item xs={12} sx={{ mt: 2 }}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", sm: "row" },
                          gap: 2,
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          type="submit"
                          variant="contained"
                          sx={{
                            bgcolor: "#3b82f6",
                            color: "white",
                            px: { xs: 2, sm: 4 },
                            py: 1.2,
                            borderRadius: "8px",
                            textTransform: "none",
                            width: { xs: "100%", sm: "auto" },
                            "&:hover": { bgcolor: "#2563eb" },
                          }}
                        >
                          {isInEditableMode ? "Update" : "Submit"}
                        </Button>

                        {isInEditableMode && (
                          <Button
                            onClick={handleCancelForm}
                            variant="contained"
                            sx={{
                              bgcolor: "#ef4444",
                              color: "white",
                              px: { xs: 2, sm: 4 },
                              py: 1.2,
                              borderRadius: "8px",
                              textTransform: "none",
                              width: { xs: "100%", sm: "auto" },
                              "&:hover": { bgcolor: "#dc2626" },
                            }}
                          >
                            Cancel
                          </Button>
                        )}

                        <Button
                          type="button"
                          onClick={resetForm}
                          variant="outlined"
                          sx={{
                            borderColor: "#fa1515ff",
                            color: "#ffffffff",
                            textTransform: "none",
                            width: { xs: "100%", sm: "auto" },
                            "&:hover": {
                              borderColor: "#fa1515ff",
                              bgcolor: "rgba(234, 8, 8, 0.1)",
                            },
                          }}
                        >
                          Reset
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </Grid>

          {/* HELPER CARD / ACCORDION */}
          <Grid item xs={12} md={4}>
            {isMobile ? (
              <Accordion
                sx={{
                  bgcolor: "#1e293b",
                  color: "white",
                  borderRadius: "16px",
                  border: "1px solid #334155",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ChevronDown size={18} color="#cbd5e1" />}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <LayoutDashboard size={18} color="#3b82f6" />
                    <Typography sx={{ fontWeight: 600, fontSize: "0.95rem" }}>
                      HTTP Source Help
                    </Typography>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <CardContent sx={{ p: 0 }}>
                    <Box display="flex" gap={2} mb={2}>
                      <Box
                        sx={{
                          p: 1.2,
                          color: "#3b82f6",
                          bgcolor: "rgba(59,130,246,0.15)",
                          borderRadius: "50%",
                          display: "flex",
                          width: 40,
                          height: 40,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <LayoutDashboard size={18} />
                      </Box>

                      <Box>
                        <Typography fontWeight={600} fontSize="0.95rem">
                          Need help configuring?
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: "rgba(255,255,255,0.6)" }}
                        >
                          Ensure your HTTP endpoint is reachable and responds
                          with JSON. Use keys like <code>data</code> or{" "}
                          <code>items[0].value</code> to extract metrics.
                        </Typography>
                      </Box>
                    </Box>

                    <Divider sx={{ mb: 2, borderColor: "#334155" }} />

                    <Box display="flex" gap={2}>
                      <Box
                        sx={{
                          p: 1.2,
                          color: "#3b82f6",
                          bgcolor: "rgba(59,130,246,0.15)",
                          borderRadius: "50%",
                          display: "flex",
                          width: 40,
                          height: 40,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Database size={18} />
                      </Box>

                      <Box>
                        <Typography fontWeight={600} fontSize="0.95rem">
                          Sample Configuration
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: "rgba(255,255,255,0.6)" }}
                        >
                          URL:{" "}
                          <code>
                            https://jsonplaceholder.typicode.com/posts/1
                          </code>
                          <br />
                          Method: <code>GET</code>
                          <br />
                          Key: <code>title</code>
                        </Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </AccordionDetails>
              </Accordion>
            ) : (
              <Card
                sx={{
                  bgcolor: "#1e293b",
                  color: "white",
                  borderRadius: "16px",
                  border: "1px solid #334155",
                  p: 2,
                }}
              >
                <CardContent>
                  {/* Block 1 */}
                  <Box display="flex" gap={2} mb={2}>
                    <Box
                      sx={{
                        p: 1.2,
                        color: "#3b82f6",
                        bgcolor: "rgba(59,130,246,0.15)",
                        borderRadius: "50%",
                        display: "flex",
                        width: 45,
                        height: 45,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <LayoutDashboard size={20} />
                    </Box>

                    <Box>
                      <Typography fontWeight={600}>
                        Need help configuring?
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "rgba(255,255,255,0.6)" }}
                      >
                        Ensure your HTTP endpoint is reachable and responds with
                        JSON. Use keys like <code>data</code> or{" "}
                        <code>items[0].value</code> to extract metrics.
                      </Typography>
                    </Box>
                  </Box>

                  <Divider sx={{ mb: 2, borderColor: "#334155" }} />

                  {/* Block 2 */}
                  <Box display="flex" gap={2}>
                    <Box
                      sx={{
                        p: 1.2,
                        color: "#3b82f6",
                        bgcolor: "rgba(59,130,246,0.15)",
                        borderRadius: "50%",
                        display: "flex",
                        width: 45,
                        height: 45,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Database size={20} />
                    </Box>

                    <Box>
                      <Typography fontWeight={600}>
                        Sample Configuration
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "rgba(255,255,255,0.6)" }}
                      >
                        URL:{" "}
                        <code>
                          https://jsonplaceholder.typicode.com/posts/1
                        </code>
                        <br />
                        Method: <code>GET</code>
                        <br />
                        Key: <code>title</code>
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            )}
          </Grid>
        </Grid>

        {/* TABLE SECTION */}
        {ursource.charAt(0) === "1" && (
          <Card
            sx={{
              mt: 4,
              bgcolor: "#0f1729",
              color: "white",
              borderRadius: "16px",
              border: "1px solid #1e293b",
              p: { xs: 2, md: 3 },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: { xs: "flex-start", sm: "center" },
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 1, sm: 0 },
                mb: 2,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: "1rem", md: "1.1rem" },
                }}
              >
                Current HTTP Data Sources
              </Typography>

              <TextField
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search sources..."
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search size={18} color="#64748b" />
                    </InputAdornment>
                  ),
                  sx: {
                    bgcolor: "rgba(255,255,255,0.05)",
                    borderRadius: "8px",
                    color: "white",
                  },
                }}
                sx={{
                  width: { xs: "100%", sm: 280 },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#334155",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#60a5fa",
                  },
                }}
              />
            </Box>

            {isPending && (
              <Box
                sx={{
                  py: 6,
                  textAlign: "center",
                  color: "rgba(148,163,184,0.9)",
                }}
              >
                <Typography variant="h6">Loading...</Typography>
              </Box>
            )}

            {error && !isPending && (
              <Box
                sx={{
                  py: 6,
                  textAlign: "center",
                  color: "rgba(248,113,113,0.9)",
                }}
              >
                <Typography variant="h6">
                  Cannot fetch the data right now!
                </Typography>
              </Box>
            )}

            {!isPending && !error && sources && sources.data && (
              <>
                {/* Delete All Button */}
                {selectedRows.length > 0 && (
                  <Box
                    sx={{
                      mb: 3,
                      p: 2,
                      bgcolor: "rgba(239, 68, 68, 0.1)",
                      border: "2px solid #ef4444",
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      flexDirection: { xs: "column", sm: "row" },
                      gap: 2,
                    }}
                  >
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
                    >
                      <Box
                        sx={{
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          bgcolor: "rgba(239, 68, 68, 0.2)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Trash2 size={20} color="#ef4444" />
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 600, color: "#fca5a5" }}>
                          {selectedRows.length} source
                          {selectedRows.length > 1 ? "s" : ""} selected
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: "rgba(252, 165, 165, 0.8)" }}
                        >
                          {selectedRows.length === rows?.data?.length
                            ? "You're about to delete all HTTP data sources"
                            : "You're about to delete the selected sources"}
                        </Typography>
                      </Box>
                    </Box>
                    <Button
                      variant="contained"
                      startIcon={<Trash2 size={18} />}
                      onClick={handleDeleteSelected}
                      sx={{
                        bgcolor: "#ef4444",
                        color: "white",
                        textTransform: "none",
                        fontWeight: 600,
                        px: 3,
                        py: 1,
                        width: { xs: "100%", sm: "auto" },
                        "&:hover": {
                          bgcolor: "#dc2626",
                        },
                      }}
                    >
                      Delete Selected
                    </Button>
                  </Box>
                )}

                {rows?.data?.length === 0 ? (
                  <Box
                    sx={{
                      py: 8,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "rgba(148,163,184,0.8)",
                      textAlign: "center",
                    }}
                  >
                    <Database size={60} color="#64748b" />
                    <Typography
                      variant="h6"
                      sx={{
                        mt: 2,
                        fontWeight: 500,
                        color: "#cbd5e1",
                        fontSize: { xs: "1rem", md: "1.1rem" },
                      }}
                    >
                      Currently, there are no HTTP data sources!
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        mt: 1,
                        color: "rgba(148,163,184,0.8)",
                        fontSize: { xs: "0.85rem", md: "0.9rem" },
                      }}
                    >
                      Add your first HTTP source using the form above.
                    </Typography>
                  </Box>
                ) : (
                  <Box>
                    <Box sx={{ overflowX: "auto" }}>
                      <MuiTable
                        sx={{
                          minWidth: 900,
                          bgcolor: "#0f1729",
                          borderRadius: "12px",
                        }}
                      >
                        <TableHead>
                          <TableRow
                            sx={{
                              bgcolor: "#1e293b",
                              "& th": {
                                color: "#94a3b8",
                                fontWeight: 600,
                                borderBottom: "1px solid #334155",
                              },
                            }}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                sx={{ color: "#bfbfbfff" }}
                                checked={
                                  rows?.data?.length > 0 &&
                                  selectedRows.length === rows?.data?.length
                                }
                                indeterminate={
                                  selectedRows.length > 0 &&
                                  selectedRows.length < rows?.data?.length
                                }
                                onChange={(e) =>
                                  handleSelectAll(e.target.checked)
                                }
                              />
                            </TableCell>

                            {visibleRows.columns.map((col) => (
                              <TableCell key={col.field}>{col.title}</TableCell>
                            ))}

                            <TableCell align="right">Actions</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {visibleRows.data.map((row) => (
                            <TableRow
                              key={row.id}
                              sx={{
                                "& td": {
                                  color: "#e2e8f0",
                                  borderBottom: "1px solid #1e293b",
                                },
                                "&:hover": {
                                  backgroundColor: "rgba(255,255,255,0.03)",
                                },
                              }}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  sx={{ color: "#d6d6d6ff" }}
                                  checked={selectedRows.some(
                                    (r) => r.id === row.id
                                  )}
                                  onChange={(e) =>
                                    handleRowSelect(e.target.checked, row)
                                  }
                                />
                              </TableCell>

                              {visibleRows.columns.map((col) => (
                                <TableCell key={col.field}>
                                  {col.field === "enable" ? (
                                    <Chip
                                      label={row.enable ? "Active" : "Inactive"}
                                      color={row.enable ? "success" : "error"}
                                      size="small"
                                      sx={{ fontWeight: 700 }}
                                    />
                                  ) : col.field === "name" ? (
                                    <Typography sx={{ fontWeight: 600 }}>
                                      {row[col.field]}
                                    </Typography>
                                  ) : col.field === "URL" ? (
                                    <Typography
                                      sx={{
                                        color: "#60a5fa",
                                        cursor: "pointer",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {row[col.field]}
                                    </Typography>
                                  ) : col.field === "method" ? (
                                    <Typography sx={{ fontWeight: 700 }}>
                                      {row[col.field]}
                                    </Typography>
                                  ) : (
                                    row[col.field]
                                  )}
                                </TableCell>
                              ))}

                              <TableCell align="right">
                                <Box
                                  sx={{
                                    display: "flex",
                                    gap: 1,
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                  }}
                                >
                                  {ursource.charAt(2) === "1" && (
                                    <IconButton
                                      onClick={(e) => handleEditButton(e, row)}
                                      sx={{
                                        color: "#64748b",
                                        "&:hover": { color: "#3b82f6" },
                                      }}
                                    >
                                      <Edit2 size={18} />
                                    </IconButton>
                                  )}

                                  {ursource.charAt(3) === "1" && (
                                    <IconButton
                                      onClick={(e) =>
                                        handleDeleteButton(e, row)
                                      }
                                      sx={{
                                        color: "#64748b",
                                        "&:hover": { color: "#ef4444" },
                                      }}
                                    >
                                      <Trash2 size={18} />
                                    </IconButton>
                                  )}
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </MuiTable>
                    </Box>

                    {/* Pagination */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mt: 2,
                        color: "#94a3b8",
                        fontSize: "0.85rem",
                      }}
                    >
                      <span>
                        Showing {currentPage} of {totalPages} pages
                      </span>

                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Button
                          variant="outlined"
                          onClick={() => setCurrentPage((p) => p - 1)}
                          disabled={currentPage === 1}
                          sx={{
                            borderColor: "#334155 !important",
                            color: "rgba(255,255,255,0.6) !important",
                            textTransform: "none",
                            "&.Mui-disabled": {
                              borderColor: "#334155",
                              color: "rgba(255,255,255,0.4)",
                              opacity: 1,
                            },
                          }}
                        >
                          Prev
                        </Button>

                        <Button
                          variant="outlined"
                          onClick={() => setCurrentPage((p) => p + 1)}
                          disabled={currentPage === totalPages}
                          sx={{
                            borderColor: "#334155 !important",
                            color: "rgba(255,255,255,0.6) !important",
                            textTransform: "none",
                            "&.Mui-disabled": {
                              borderColor: "#334155",
                              color: "rgba(255,255,255,0.4)",
                              opacity: 1,
                            },
                          }}
                        >
                          Next
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                )}
              </>
            )}
          </Card>
        )}
      </Box>
    </Box>
  );
};

export default HTTPSources;
